// extracted by mini-css-extract-plugin
export default {"benefitList":"benefit_cadastre_list_benefitList__LfqaK","Mui-focused":"benefit_cadastre_list_Mui-focused__7tcg-","label":"benefit_cadastre_list_label__vzQeT"};